import { Head, useForm, Link } from '@inertiajs/react'
import { FormEvent } from 'react'

interface LoginProps {
  errors?: {
    email_address?: string[]
  }
}

export default function Login({ errors }: LoginProps) {
  const { data, setData, post, processing } = useForm({
    email_address: '',
    password: '',
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/session')
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12 sm:px-6 lg:px-8">
      <Head title="Log In" />
      <div className="w-full max-w-md space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            Log in to your account
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Or{' '}
            <Link href="/register" className="font-medium text-indigo-600 hover:text-indigo-500">
              create a new account
            </Link>
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4 rounded-md">
            <div>
              <label htmlFor="email_address" className="block text-sm font-medium text-gray-700">
                Email address
              </label>
              <input
                id="email_address"
                name="email_address"
                type="email"
                autoComplete="email"
                required
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                value={data.email_address}
                onChange={(e) => setData('email_address', e.target.value)}
              />
              {errors?.email_address && (
                <p className="mt-1 text-sm text-red-600">{errors.email_address[0]}</p>
              )}
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                value={data.password}
                onChange={(e) => setData('password', e.target.value)}
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={processing}
              className="group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50"
            >
              Log in
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
